import {
  Box,
  Container,
  VStack,
  useToast,
  Text,
  Button as CButton,
  Image,
  Badge,
  useClipboard,
  HStack,
} from "@chakra-ui/react";

import { CopyIcon } from "@chakra-ui/icons";
import { ReactComponent as Logo } from "assets/logos/s-logo.svg";
import Button from "components/Button/Button";
import { useRef, useEffect } from "react";
import Recaptcha from "react-google-recaptcha";

import {
  useEnable2faMutation,
  useGenerate2faMutation,
} from "services/arbitraryApi";

import { useHistory, useLocation } from "react-router-dom";

const TwoFaGenerate = () => {
  const toast = useToast();
  const history = useHistory();
  const location = useLocation();

  const recaptchaInstanceRef = useRef();

  const [enable2fa, { isLoading, isSuccess, isError, error, data }] =
    useEnable2faMutation();

  const [
    generate2fa,
    {
      isLoading: isGenerating,
      isSuccess: hasGenerated,
      isError: generateHasError,
      error: generate2faError,
      data: generate2faData,
    },
  ] = useGenerate2faMutation();

  const { hasCopied, onCopy } = useClipboard(generate2faData?.secret ?? "");

  useEffect(() => {
    if (hasCopied) {
      toast({
        title: "Copied!",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [toast, hasCopied]);

  const getError = (error) => {
    function isObj(obj) {
      var type = typeof obj;
      return type === "function" || (type === "object" && !!obj);
    }
    const value = isObj(error) ? Object.values(error)[0] : error;
    // console.log("ERROR VALUE", value);
    return value ?? "An unexpected error occurred";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (navigator.onLine === true) {
      enable2fa();
    } else {
      toast({
        position: "bottom-right",
        title: "Network Error!!",
        description: "Please check your network connection",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (isSuccess) {
      console.log("2FA VERIFICATION RESULT", data);
      toast({
        position: "bottom-right",
        title: "Success",
        description: "2FA is now enabled on your account 🥳👍",
        status: "success",
        duration: 9000,
        isClosable: true,
      });

      history.replace("/2faenter");
    }

    if (isError && error) {
      console.log("2FA VERIFICATION ERROR", error);
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [
    isSuccess,
    data,
    isError,
    error,
    generate2faData,
    hasGenerated,
    toast,
    history,
  ]);

  useEffect(() => {
    if (hasGenerated && generate2faData) {
      console.log("GENERATE 2FA Data", generate2faData);
      toast({
        position: "bottom-right",
        title: "Success",
        description: "Generated 2fa successfully",
        status: "success",
        duration: 9000,
        isClosable: true,
      });

      //   history.replace("/dashboard/home");
    }

    if (generateHasError && generate2faError) {
      console.log("GENERATE 2FA ERROR", generate2faError);
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description: getError(generate2faError?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [
    isGenerating,
    generate2fa,
    generateHasError,
    generate2faError,
    toast,
    history,
    generate2faData,
    hasGenerated,
  ]);

  return (
    <VStack py={["10px", "20px"]} minH="100vh" alignItems="center">
      <Container maxW="lg">
        <Box bg="#fcfcfc" p={["10px", "16px", "28px"]}>
          <HStack justifyContent="flex-end" p="10px" mb="20px">
            {location.search === "?btm" ? (
              ""
            ) : (
              <CButton
                variant="link"
                size="sm"
                _focus={{ shadow: "0 0 0 3px #02a4387f" }}
                onClick={() => history.replace("/dashboard/home")}
              >
                Skip
              </CButton>
            )}
          </HStack>
          <VStack>
            <Box w={["100px", "initial"]} as={Logo} />
            {/* <Heading as="h3" fontSize={["24px", "32px"]}>
              Welcome
            </Heading> */}
            <Text
              textAlign="center"
              fontSize={["32px", "2xl"]}
              mt="24px !important"
            >
              Two-Factor Authentication
            </Text>
            <Text
              textAlign="center"
              fontSize={["sm", "md"]}
              color="#4e4b66"
              mt="24px !important"
            >
              Set up two-factor aunthenticator by generating and scanning the
              google authenticator QR Code below or copying the secret.
            </Text>
          </VStack>

          <Box as="form" mt="50px" onSubmit={handleSubmit}>
            <VStack>
              {!generate2faData && (
                <Button
                  disabled={isGenerating}
                  isLoading={isGenerating}
                  minW="100%"
                  minH="56px"
                  fontWeight="normal"
                  onClick={() => generate2fa()}
                >
                  Generate
                </Button>
              )}

              {generate2faData && (
                <VStack>
                  <Image
                    boxSize="180px"
                    src={generate2faData?.qrCodeLink}
                    alt="2fa qr code"
                  />
                  <CButton
                    size="xs"
                    maxW="md"
                    overflow="hidden"
                    whiteSpace="wrap"
                    textOverflow="ellipsis"
                    onClick={onCopy}
                    as={Badge}
                    colorScheme="green"
                    rightIcon={
                      <Box
                        bg="white"
                        p="4px"
                        borderRadius="4px"
                        pos="relative"
                        right="-6px"
                      >
                        <CopyIcon />
                      </Box>
                    }
                    bg="green.100"
                    color="black"
                    _hover={{ bg: "green.200" }}
                  >
                    SECRET:{"  "}
                    <Text ml="4px" maxW="220px" color="green.500">
                      {generate2faData?.secret}
                    </Text>
                  </CButton>
                </VStack>
              )}

              {generate2faData && (
                <Button
                  minW="100%"
                  disabled={isLoading}
                  isLoading={isLoading}
                  minH="56px"
                  fontWeight="normal"
                  mt="30px !important"
                  type="submit"
                >
                  Enable
                </Button>
              )}

              <Recaptcha
                ref={recaptchaInstanceRef}
                sitekey={process.env.REACT_APP_RECAPTCHA}
                size={"invisible"}
              />
            </VStack>
          </Box>
        </Box>
      </Container>
    </VStack>
  );
};

export default TwoFaGenerate;
